export const relationshipOptions = ['Neighbor', 'Friend', 'Landlord', 'Business', 'Other'];

export const roleOptions = ['Own', 'Rent', 'MilitaryHousing', 'Other'];

//PVQ Dropdown values
export const temporaryLivingSituationOptions = [
  'Extended Travel',
  'Business',
  'School',
  'Military Training',
  'Military Deployment',
  'Other',
];
